(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ronda-email-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel = document.getElementById('RondaEmailPopup');
  if (!panel) return;
  const key = 'ronda_drops_snooze_v1';
  const sessionKey = 'ronda_drops_seen_v1';
  const pendingKey = 'ronda_drops_pending_v1';
  const read = (storage, name) => { try { return storage.getItem(name); } catch { return null; } };
  const write = (storage, name, value) => { try { storage.setItem(name, value); } catch {} };
  const hide = () => { panel.hidden = true; write(localStorage, key, String(Math.max(Number(read(localStorage,key)) || 0, Date.now() + 7*86400000))); };
  panel.querySelector('.ronda-drop__close').addEventListener('click', hide);
  panel.addEventListener('keydown', e => { if(e.key === 'Escape') { hide(); panel.querySelector('input')?.blur(); } });
  const ownReturn = location.hash === '#RondaDropForm' || read(sessionStorage,pendingKey) === '1';
  if(ownReturn && (panel.querySelector('[data-ronda-success]') || panel.querySelector('[data-ronda-error]'))) {
    panel.hidden = false;
    if(panel.querySelector('[data-ronda-success]')) write(localStorage,key,String(Date.now()+180*86400000));
    write(sessionStorage,pendingKey,'0');
    return;
  }
  panel.querySelector('form')?.addEventListener('submit', () => write(sessionStorage,pendingKey,'1'));
  if(new URLSearchParams(location.search).get('ronda_popup') === 'preview') { panel.hidden = false; return; }
  if(Number(read(localStorage,key)) > Date.now() || read(sessionStorage,sessionKey)) return;
  let engaged = false;
  let elapsed = false;
  const maybeShow = () => {
    if(!engaged || !elapsed || document.visibilityState !== 'visible') return;
    if(document.querySelector('dialog[open],cart-drawer.active,.cart-notification.active,details[open].menu-opening')) return;
    if(document.activeElement?.matches('input,textarea,select')) return;
    if(location.pathname.includes('/products/')) return;
    panel.hidden = false;
    write(sessionStorage,sessionKey,'1');
    write(localStorage,key,String(Date.now()+7*86400000));
    window.removeEventListener('scroll',engage);
    window.removeEventListener('pointerdown',engage);
    document.removeEventListener('visibilitychange',maybeShow);
  };
  const engage = () => { engaged = true; maybeShow(); };
  window.addEventListener('scroll',engage,{passive:true});
  window.addEventListener('pointerdown',engage,{passive:true});
  document.addEventListener('visibilitychange',maybeShow);
  window.setTimeout(() => {elapsed=true;maybeShow();},20000);
})();
  } catch(e) { console.error(e); }
})();

})();
